import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';
const SC_BRUEHL_LOGO = 'https://scbruehl.ch/wp-content/themes/scbruehl/assets/img/scb_logo.svg';

export default function VerifyEmailPage() {
    const { token } = useParams();
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [message, setMessage] = useState('');

    useEffect(() => {
        const verify = async () => {
            try {
                const res = await axios.get(`${API_URL}/auth/verify-email/${token}`);
                setMessage(res.data.message);
                setStatus('success');
            } catch (error) {
                setMessage(error.response?.data?.detail || 'Bestätigung fehlgeschlagen.');
                setStatus('error');
            }
        };
        if (token) verify();
    }, [token]);

    return (
        <div className="auth-background min-h-screen flex items-center justify-center p-4">
            <div className="w-full max-w-md animate-scale-in">
                <div className="text-center mb-8">
                    <img src={SC_BRUEHL_LOGO} alt="SC Brühl St. Gallen" className="w-20 h-20 mx-auto mb-4" />
                    <h1 className="text-4xl font-heading text-white tracking-tight">Kronentipp</h1>
                    <p className="text-green-200 mt-2 font-body">SC Brühl St. Gallen - Tippspiel</p>
                </div>

                <Card className="glass-card border-white/10">
                    <CardContent className="pt-8 pb-8 text-center space-y-5">
                        {status === 'loading' && (
                            <>
                                <div className="flex justify-center">
                                    <Loader2 className="w-12 h-12 text-[#00ad43] animate-spin" />
                                </div>
                                <p className="text-muted-foreground">Email wird bestätigt...</p>
                            </>
                        )}

                        {status === 'success' && (
                            <>
                                <div className="flex justify-center">
                                    <div className="w-16 h-16 rounded-full bg-[#00ad43]/20 flex items-center justify-center">
                                        <CheckCircle className="w-9 h-9 text-[#00ad43]" />
                                    </div>
                                </div>
                                <h2 className="text-xl font-semibold" data-testid="verify-success-title">{message}</h2>
                                <Link to="/login">
                                    <Button className="btn-primary gap-2 mt-2" data-testid="verify-login-button">
                                        Jetzt anmelden
                                    </Button>
                                </Link>
                            </>
                        )}

                        {status === 'error' && (
                            <>
                                <div className="flex justify-center">
                                    <div className="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center">
                                        <XCircle className="w-9 h-9 text-red-500" />
                                    </div>
                                </div>
                                <h2 className="text-xl font-semibold text-red-600" data-testid="verify-error-title">Bestätigung fehlgeschlagen</h2>
                                <p className="text-muted-foreground text-sm">{message}</p>
                                <Link to="/register">
                                    <Button variant="outline" className="gap-2 mt-2" data-testid="verify-register-button">
                                        Erneut registrieren
                                    </Button>
                                </Link>
                            </>
                        )}
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
